import { render, staticRenderFns } from "./index.vue?vue&type=template&id=afd61b8a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=afd61b8a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd61b8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afd61b8a')) {
      api.createRecord('afd61b8a', component.options)
    } else {
      api.reload('afd61b8a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=afd61b8a&scoped=true", function () {
      api.rerender('afd61b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/dashboard/index.vue"
export default component.exports